import React, { useEffect, useMemo, useState } from "react";
import jwt_decode from "jwt-decode";
import { AvaBlank, AvaBoy, AvaGirl, MyCard, PICBlank } from "./ProfileUI";
import { ProgressBarProfile } from "./ProgressProfile";
import { CalculatePersentaseProfile } from "../_core/_core";
import { StudentIDFormat } from "../../../../Library/GlobalHelper";
import { RSAencryptData } from "../../../StudentNewComming/Documents/RSAEnc";
import { DOWNLOAD_REQUEST_DOC } from "../../../StudentNewComming/APIS";

const AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];

export function StdHeader({ children, student }) {
  const doc_req_name = `pas_foto_file_${student.studentid}`;
  const local_name_pp = `blob_pp_${student.studentid}`;
  const doc_local = localStorage.getItem(doc_req_name) || "";

  const [has_pp, setHasPP] = useState("");
  const [file_id, setFileId] = useState("");

  useEffect(() => {
    const getFileId = () => {
      if (doc_local) {
        console.log("doc_local:", doc_local);
        try {
          const doc_data = JSON.parse(doc_local);
          console.log("doc_data:", doc_data);
          return doc_data?.file_id || "";
        } catch (error) {
          console.error("Error parsing doc_local JSON:", error);
          // Bersihkan localStorage jika data corrupt
          localStorage.removeItem(doc_req_name);
          return "";
        }
      } else {
        return "";
      }
    };

    const newFileId = getFileId();
    setFileId(newFileId);
  }, [student, doc_local]);

  const RenderPP = async (file_id) => {
    try {
      const objData = JSON.stringify({
        file_id: file_id,
        user: AuthDecode?.identity?.email || "",
      });
      // console.log(objData);
      const rsaEnc = RSAencryptData(objData);
      const formData = new FormData();
      formData.append("data", rsaEnc);
      formData.append("file", []);
      const download = await DOWNLOAD_REQUEST_DOC(formData);
      if (download.status === 200) {
        if (download.data.type.startsWith("image/")) {
          const reader = new FileReader();
          reader.onloadend = function () {
            const base64data = reader.result;
            const currentBlobSize = calculateBlobStorageSize("blob_pp_");
            const FOUR_MB = 4 * 1024 * 1024;

            if (currentBlobSize < FOUR_MB) {
              try {
                localStorage.setItem(local_name_pp, base64data);
              } catch (e) {
                if (e.name === "QuotaExceededError") {
                  console.warn(
                    `Gagal menyimpan gambar di localStorage untuk ${local_name_pp}: Melebihi kuota.`,
                  );
                } else {
                  console.error("Gagal menyimpan ke localStorage:", e);
                }
              }
            } else {
              console.warn(
                "Penyimpanan localStorage untuk blob gambar telah melebihi 4MB. Penyimpanan dihentikan.",
              );
            }
            setHasPP(base64data);
          };
          reader.readAsDataURL(download.data);
        } else {
          try {
            localStorage.setItem(local_name_pp, "");
          } catch (e) {
            console.error("Gagal membersihkan localStorage:", e);
          }
          setHasPP("");
        }
      } else {
        try {
          localStorage.setItem(local_name_pp, "");
        } catch (e) {
          console.error("Gagal membersihkan localStorage:", e);
        }
        setHasPP("");
      }
    } catch (error) {
      setHasPP("");
    }
  };

  useEffect(() => {
    const loadData2 = async () => {
      const storedData = localStorage.getItem(local_name_pp);
      if (storedData) {
        try {
          setHasPP(storedData);
        } catch (error) {
          console.error("Error parsing stored data:", error);
          await RenderPP(file_id);
        }
      } else {
        await RenderPP(file_id);
      }
    };

    if (file_id) {
      loadData2();
    }
  }, [file_id, local_name_pp]);

  const total_calculate = useMemo(() => {
    return CalculatePersentaseProfile(student);
  }, [student]);

  return (
    <MyCard>
      <div className="py-6">
        <div className="d-flex flex-wrap flex-sm-nowrap">
          <ProfilePicture student={student} profile_pic={has_pp} />

          <div className="flex-grow-1">
            <div className="d-flex justify-content-between align-items-start flex-wrap mb-2 flex-wrap">
              <InfoGeneral data={student} />
              <div>
                <div className="badge badge-light px-6 py-3 h6 mr-2">
                  {student?.status?.name || "-"} Student (
                  {student?.enrollment_type?.name || ""}
                  {student?.transfer_type?.name
                    ? ` - ${student.transfer_type.name}`
                    : ""}
                  )
                </div>

                <div className="badge badge-light px-6 py-3 h6">
                  Semester {student?.semester || "-"}
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center pe-8">
              <div className="d-flex flex-wrap">
                <BoxInfo
                  title={student?.program?.name || ""}
                  value={
                    student.clu_spec
                      ? student.clu_spec?.name || "-"
                      : student.clu?.name || "-"
                  }
                />
                <BoxInfo title={"Intake"} value={student?.term_intake?.name} />
              </div>
              <div
                className="d-flex justify-content-center"
                style={{ width: "250px" }}
              >
                <ProgressBarProfile
                  total_percentage={total_calculate?.completion_percentage || 0}
                />
                {/* <ProgressProfile title={"Profile Completion"} percentage={total_calculate?.completion_percentage || 0} /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {children}
    </MyCard>
  );
}

const ProfilePicture = ({ profile_pic, student }) => {
  return (
    <div className="mr-0">
      <div className="symbol symbol-150 symbol-light mr-4 symbol-fixed position-relative">
        {profile_pic ? (
          <div
            className="bg-light-primary p-1 h-150px w-150px rounded"
            style={{
              backgroundImage: profile_pic
                ? `url(${profile_pic})`
                : `url(${PICBlank})`,
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          ></div>
        ) : student.gender === "p" ? (
          <AvaBoy className="bg-light-primary p-1" />
        ) : student.gender === "w" ? (
          <AvaGirl className="bg-light-primary p-1" />
        ) : (
          <AvaBlank className="bg-light-primary p-1" />
        )}
      </div>
    </div>
  );
};

const InfoGeneral = ({ data }) => {
  return (
    <div>
      <div className="d-flex align-items-center mb-2">
        <span className="text-gray-900 h1 font-weight-bold mr-1 text-capitalize">
          {data?.fullname || "-"}
        </span>
        <i className={`fa fa-check h1 text-primary`}></i>
      </div>
      <div className="d-flex flex-wrap fw-semibold h6 pe-2">
        <LabelIcon
          icon={"flaticon2-user"}
          value={StudentIDFormat(data?.studentid)}
        />
        <LabelIcon
          icon={"flaticon2-black-back-closed-envelope-shape"}
          value={data?.sgumail || "-"}
        />
        <LabelIcon icon={"flaticon2-phone"} value={data?.cellular || "-"} />
        {data.cgpa ? (
          <LabelIcon
            icon={"flaticon2-line-chart"}
            value={"CGPA " + data?.cgpa || "-"}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

const LabelIcon = ({ icon, value }) => {
  return (
    <span className="d-flex align-items-center mr-5">
      <i className={`icon-1x text-gray-500 ${icon} mr-1`}></i>
      <span className="text-gray-500">{value}</span>
    </span>
  );
};

const BoxInfo = ({ title, value }) => {
  return (
    <div className="border border-dashed border-gray-300 rounded py-3 px-3 mb-3 min-w-80px mr-3">
      <div className="h4 fw-bolder text-gray-700 text-center">{value}</div>
      <span className="">{title}</span>
    </div>
  );
};

const calculateBlobStorageSize = (prefix) => {
  let total = 0;
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith(prefix)) {
      const value = localStorage.getItem(key);
      if (value) {
        total += new Blob([value]).size;
      }
    }
  }
  return total;
};
